import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { withApi } from "@tencent/react-aio"
import * as ActionTypes from "@/stores/sale/actions"
import _ from "lodash"
import dayjs from "dayjs"

// 判断employeeId是否为teamId的负责人，如果是则显示星星
class LeaderStar extends React.Component {
  static propTypes = {
    userId: PropTypes.number,
    teamId: PropTypes.number,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    leaders: PropTypes.arrayOf(PropTypes.object),
  }

  // 默认按照今天的负责人计算，是否显示负责人星星
  static defaultProps = {
    startDate: dayjs().format("YYYY-MM-DD"),
    endDate: dayjs().format("YYYY-MM-DD"),
  }

  componentDidMount() {
    const { webApi, leaders, endDate } = this.props
    if (!leaders) {
      webApi.getOrganizationTreeIfNeed().dispatch(ActionTypes.FETCH_ORGANIZATION_TREE_WITH_DATE_RANGE, {
        data: {
          snapshot_date: endDate,
        },
      })
    }
  }

  render() {
    const { leaders, userId } = this.props
    if (leaders instanceof Array) {
      if (
        leaders.some(function (item) {
          return item.userId === userId
        })
      ) {
        return <span className="fa fa-star" title="负责人" style={{ marginLeft: 2, color: "orange" }} />
      }
    }
    return ""
  }
}

function mapStateToProps(state, ownProps) {
  // 所有符合teamId的负责人
  let leaders = null

  // 遍历树查找负责人
  if (state.organizationTree.treeWithDateRange) {
    leaders = {}
    const findLeader = (teams) => {
      teams instanceof Array &&
        teams.forEach((team) => {
          findLeader(team.children)

          team.employees instanceof Array &&
            team.employees.forEach((employee) => {
              employee.records instanceof Array &&
                employee.records.forEach((record) => {
                  if (record.teamId === ownProps.teamId && record.grade === 1 && !dayjs(ownProps.startDate).isAfter(dayjs(record.endDate)) && !dayjs(ownProps.endDate).isBefore(dayjs(record.beginDate))) {
                    leaders[employee.userId] = employee
                  }
                })
            })
        })
    }

    findLeader(state.organizationTree.treeWithDateRange.teams)
    // 对象转数组
    leaders = Object.keys(leaders).map((userId) => {
      return leaders[userId]
    })
  }

  return {
    leaders: leaders,
  }
}

export default withApi(connect(mapStateToProps)(LeaderStar))
